<template>
  <div class="container page" style="background-color: #1f1c1f;">
    <van-nav-bar :title="$t('my.task_record')" class="nav-bar">
      <template #left>
        <img src="/img/newLogin/download.png" @click="back()" style="width: 20px;height: 15px;"/>
      </template>
      <template #right>
        <van-icon name="wap-home-o" color="#937960" size="26" @click="goHome" />
      </template>
    </van-nav-bar>
 
    <div class="main">
      <van-pull-refresh
        v-model="isLoading"
        @refresh="onRefresh"
        :pulling-text="$t('index.loading')"
        :loosing-text="$t('index.loading')"
        :loading-text="$t('index.loading')"
      >
        <div class="hd">
          <div class="count all">
            {{$t("q61")}}:<span class="ruzhang">{{formatTotalProfit()}}</span>
          </div>
          <div class="search" :class="{'is_hidden': isHidden}">
          </div>
          <!-- <a class="fold" :class="{'fold_up': foldup, 'fold_down': folddown}" @click="handleFold"></a> -->
          <a class="fold" :class="{'fold_up': foldup, 'fold_down': folddown}"></a>
        </div>
        <van-loading v-if="loading" type="spinner" vertical>{{$t("index.loading")}}</van-loading>
        <van-empty v-else-if="!loading && list.length === 0" :description="$t('withdraw.empty_data')" />
        <div v-else class="record-list">
          <div class="record-item" v-for="(v, key) in list" :key="key">
            <!-- <div class="record-header">
              <div class="left-info">
                <span class="order-id">{{v.expect}}</span>
                <span class="status" :class="{'status-success': v.status === 1}">
                  {{v.status === 1 ? $t('setting.ok') : $t('setting.cancel')}}
                </span>
              </div>
              <div class="amount" :class="{'amount-success': v.status === 1}">
                {{v.money}}
              </div>
            </div> -->
            <!-- <div class="record-body">
              <div class="result-info">
                <span class="label">{{$t("reservation.result")}}</span>
                <div class="result-tags">
                  <span class="result-tag">{{v.size}}</span>
                  <span class="result-tag">{{v.double}}</span>
                </div>
              </div>
              <div class="bet-info" v-if="v.data && v.data.length">
                <span class="label">{{$t("q36")}}</span>
                <div class="bet-tags">
                  <span class="bet-tag" v-for="(citem, index) in v.data" :key="index">
                    {{calcSize(citem.type)}}
                  </span>
                </div>
              </div>
              <div class="time-info">
                <div class="time">
                  <van-icon name="clock-o" />
                  <span>{{$t("reservation.order_time")}}：{{v.create_time}}</span>
                </div>
                <div class="time">
                  <van-icon name="clock-o" />
                  <span>{{$t("reservation.settle_time")}}：{{v.update_time}}</span>
                </div>
              </div>
            </div> -->
            <ul>
              <li class="w50 tl qishu">{{v.expect}}</li>
              <li class="w50 tr time">{{v.create_time}}</li>
              <li class="w30 val">{{formatMoney(v.money)}}</li>
              <li class="w70 tr f12 num">{{$t("reservation.settle_time")}}：{{getDisplaySettleTime(v)}}</li>
              <li class="w50" style="margin-bottom: 2vw; margin-top: -2vw;">
                <span
                  :style="{ color: getProfitTextColor(v), lineHeight: '8vw' }"
                >
                  {{ getProfitDisplayText(v) }}
                </span>
              </li>
              <li class="w50" style="margin-top: -2vw;">
                <span class="label">{{$t("q36")}}</span>
                <span class="result-tag">{{ getBetTypeLabel(v.type) }}</span>
                <span class="result-tag status-tag">{{ getGameStatusText(v) }}</span>
              </li>
            </ul>
          </div>
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isHidden: true,
      foldup: false,
      folddown: true,
      isLoading: false,
      loading: true,
      list: []
    };
  },
  methods: {
    formatMoney(value) {
      if (!value) return '0';
      // 将数值转换为整数
      let num = Math.round(parseFloat(value));
      // 转换为字符串并添加千位分隔符
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    handleFold() {
      this.foldup = !this.foldup;
      this.folddown = !this.folddown;
      this.isHidden = !this.isHidden;
    },
    back(){
      return window.history.back();
    },
    onRefresh() {
      this.getUserGameList();
    },
    getBetTypeLabel(type) {
      const labelMap = {
        big: 'lottery.big_label',
        small: 'lottery.small_label',
        one: 'lottery.odd_label',
        two: 'lottery.even_label'
      };
      return this.$t(labelMap[type] || type);
    },
    getGameStatusText(item) {
      return item.status === 1
        ? this.$t('gameRecord.settled')
        : this.$t('gameRecord.settling');
    },
    getDisplaySettleTime(item) {
      return item.status === 1
        ? item.update_time
        : this.$t('gameRecord.settling');
    },
    getProfitDisplayText(item) {
      if (item.status !== 1) {
        return this.$t('gameRecord.settling');
      }
      if (item.is_win === 1) {
        return `+${this.formatMoney(item.profit)}`;
      }
      if (item.is_win === 2) {
        return `-${this.formatMoney(item.profit)}`;
      }
      return this.formatMoney(item.profit);
    },
    getProfitTextColor(item) {
      if (item.status !== 1) {
        return '#e6b98a';
      }
      return item.is_win === 1 ? 'green' : 'red';
    },
    getUserGameList(){
      this.loading = true;
      this.$http({
        method: 'get',
        url: 'user_get_game_list'
      }).then(res => {
        this.loading = false;
        this.isLoading = false;
       
        if(res.code === 200){
          try {
            const gameData = res.data2 || [];
            let list = [];
           
            gameData.forEach(item => {
              list.push({
                ...item
              });
            });
           
            this.list = list;
          } catch(e) {
            console.error("数据处理错误:", e);
            this.$toast("数据处理错误");
          }
        }else if(res.code === 401){
          this.$toast(res.msg);
        }
      }).catch(err => {
        this.loading = false;
        this.isLoading = false;
        console.error("请求错误:", err);
        this.$toast(this.$t('withdraw.empty_data'));
      });
    },
    goHome() {
      this.$router.push('/');
    },
    formatTotalProfit() {
      let totalProfit = 0;
      if(this.list && this.list.length > 0) {
        this.list.forEach(item => {
          if(item.is_win === 1) {
            totalProfit += parseFloat(item.profit);
          } else if(item.is_win === 2) {
            totalProfit -= parseFloat(item.profit);
          }
        });
      }
      return this.formatMoney(totalProfit);
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserGameList();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

.main {
  position: relative;
  overflow: auto;
  background-color: #1f1c1f;
  height: 100%;
  padding: 15px;
}

.record-list {
  .record-item {
/*    background: linear-gradient(120deg, #212121, #313131);
    border-radius: 15px;
    margin-bottom: 20px;
    padding: 20px;
    border: 1px solid #766350;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    transition: transform 0.2s ease; */

    &:active {
      transform: scale(0.98);
    }

    .record-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 15px;
      
      .left-info {
        display: flex;
        align-items: center;
        gap: 12px;
        
        .order-id {
          color: #f3c7a2;
          font-size: 28px;
          font-weight: 600;
        }
        
        .status {
          padding: 4px 12px;
          border-radius: 20px;
          font-size: 24px;
          background: rgba(255, 255, 255, 0.1);
          color: #999;
          
          &.status-success {
            background: rgba(7, 193, 96, 0.1);
            color: #07c160;
          }
        }
      }
      
      .amount {
        color: #f3c7a2;
        font-size: 32px;
        font-weight: bold;
        
        &.amount-success {
          color: #07c160;
        }
      }
    }

    .record-body {
      display: flex;
      flex-direction: column;
      gap: 15px;

      .label {
        color: #999;
        font-size: 24px;
        margin-right: 12px;
      }

      .result-info, .bet-info {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 10px;

        .result-tags, .bet-tags {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
        }

        .result-tag, .bet-tag {
          background: linear-gradient(#fde3ca, #e7b486);
          color: #333;
          padding: 8px 20px;
          border-radius: 12px;
          font-size: 24px;
          font-weight: 600;
          white-space: nowrap;
        }
      }

      .time-info {
        display: flex;
        flex-direction: column;
        gap: 8px;

        .time {
          display: flex;
          align-items: center;
          color: #999;
          font-size: 24px;
          
          .van-icon {
            margin-right: 8px;
            font-size: 24px;
          }
        }
      }
    }
  }
}

::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
  color: #f3c7a2;
  font-size: 28px;
}

::v-deep .van-loading__text {
  color: #f3c7a2;
  font-size: 28px;
}

::v-deep .van-nav-bar {
  background-color: #1f1c1f;
  
  .van-nav-bar__title {
    color: #f3c7a2;
    font-size: 32px;
  }

  .icon-home {
    font-size: 20px;
    color: #f3c7a2;
    padding: 5px;
    cursor: pointer;
    
    &:active {
      opacity: 0.8;
    }
  }
}

::v-deep .van-empty__description {
  color: #f3c7a2;
  font-size: 28px;
}

.record-item ul {
    line-height: 4vw;
	font-size: 3.8vw;
	padding: 3vw 3vw 0vw 3vw;
	overflow: hidden;
	border: 1px solid #766350;
	background: linear-gradient(120deg, #212121, #313131);
	border-radius: 1vw;
	margin-bottom: 2.5vw;
}

.record-item ul li.tl {
    text-align: left;
}

.record-item ul li.w50 {
    float: left;
    width: 50%;
}

.record-item ul li.w30 {
    float: left;
    width: 30%;
}

.record-item ul li.w70 {
    float: left;
    width: 70%;
}

.record-item ul li.tr {
    text-align: right;
}

.record-item ul li {
    height: 8vw;
    text-align: center;
    padding: 0;
    margin: 0;
    overflow: hidden;
	color: #f3c7a2;
}

.record-item ul li.qishu {
    font-size: 3.733vw;
}

.record-item ul li.time {
    color: #999;
	font-size: 3.733vw;
}

.record-item ul li.val {
    font-size: 4.2vw;
}

.record-item ul li.num {
	font-size: 3vw;
}

.record-item ul li .label {
	color: #999;
	font-size: 3.2vw;
	margin-right: 1.6vw;
}

.record-item ul li .result-tag {
	background: linear-gradient(#fde3ca, #e7b486);
	color: #333;
	padding: 1.5vw;
	border-radius: 1vw;
	font-size: 3vw;
	line-height: 8vw;
	margin-right: 1.6vw;
}

.record-item ul li .status-tag {
	background: rgba(230, 185, 138, 0.16);
	color: #e6b98a;
	border: 1px solid rgba(230, 185, 138, 0.35);
}

.hd {
	padding: 10px 8px;
	border: 1px solid #766350;
	background: linear-gradient(120deg, #212121, #313131);
	margin-bottom: 2vw;
}

.hd .count.all {
    display: inline-block;
    background: #FFEE6E;
}

.hd .count {
    position: relative;
    height: 7vw;
    line-height: 7vw;
    padding: 0 2vw;
    color: #333;
    font-size: 3.2vw;
    border-radius: 1vw;
}

.search {
	overflow: hidden;
	height: 20vw;
	padding-top: 0px;
	margin-top: 0px;
	padding-bottom: 0px;
	margin-bottom: 0px;
}

.hd .fold_up {
	position: absolute;
	right: 2vw;
	width: 3.2vw;
	height: 3.2vw;
	border: solid #937c65;
	transform: rotate(135deg);
	border-width: 0 0 0.6vw 0.6vw;
	top: 4vw;
}

.hd .fold_down {
    position: absolute;
    right: 2vw;
    width: 3.2vw;
    height: 3.2vw;
    border: solid #937c65;
    transform: rotate(135deg);
	top: 2.5vw;
	border-width: 0.6vw 0.6vw 0 0;
}

.is_hidden {
	display: none;
}
</style>
